import { TableColumn, Link } from '@backstage/core-components';
import { TagsCell, DateTimeCell, LocationCell, StatusCell, TitleCell } from './tableCells';

interface ColumnConfig {
  showTags?: boolean;
  getDetailsPath: (params: { eventId: string }) => string;
}

export function createCalendarTableColumns(config: ColumnConfig): TableColumn[] {
  const { showTags, getDetailsPath } = config;

  return [
    {
      title: 'When',
      field: 'startTimestamp',
      width: '15%',
      render: (eventData: any) => <DateTimeCell date={eventData.date} time={eventData.time} />,
      customSort: (a: any, b: any) => a.startTimestamp - b.startTimestamp,
    },
    {
      title: 'What',
      field: 'title',
      render: (eventData: any) => (
        <TitleCell
          title={<Link to={getDetailsPath({ eventId: eventData.eventId })}>{eventData.title}</Link>}
        />
      ),
    },
    {
      title: '',
      field: 'tags',
      width: '10%',
      hidden: !showTags,
      align: 'right',
      sorting: false,
      render: (eventData: any) => <TagsCell tags={eventData.tags} />,
    },
    {
      title: 'Where',
      field: 'location',
      width: '20%',
      cellStyle: { minWidth: '150px' },
      headerStyle: { minWidth: '150px' },
      render: (eventData: any) => <LocationCell location={eventData.location} />,
    },
    {
      title: 'Status',
      field: 'id',
      width: '10%',
      align: 'center',
      sorting: false,
      render: (eventData: any) => <StatusCell eventData={eventData} />,
    },
  ];
}
